import { TimeRange } from '@hakimo-ui/hakimo/types';
import { ClockIcon } from '@heroicons/react/24/outline';

interface Props {
  timeRange?: TimeRange;
}

export function TimeRangeLabels(props: Props) {
  const { timeRange } = props;

  if (!timeRange) return null;

  return (
    <div className="border-onlight-line-3 dark:border-ondark-line-3 inline-flex items-center gap-1 rounded-full border px-2 py-1">
      <ClockIcon className="dark:text-ondark-text-2 text-onlight-text-2 h-4 w-4" />
      <span className="dark:text-ondark-text-2 text-onlight-text-2 text-xs">
        {timeRange.startTime} - {timeRange.endTime}
      </span>
    </div>
  );
}

export default TimeRangeLabels;
